import React from 'react';
import CardHeader from '../../../../shared/components/card-header/CardHeader';
import { I18nUtils } from '../../../../../i18n/I18nUtils';
import HeaderSearchRefreshFilterOptions from '../../../../shared/components/HeaderSearchRefreshFilterOptions';
import CardBody from '../../../../shared/components/CardBody';
import Row from '../../../../shared/components/Row';
import { Col } from 'react-bootstrap';
import { PsTable } from '../../../../shared/components/table/PsTable';
import classNames from 'classnames';
import { ButtonIcon } from '../../../../shared/components/ButtonIcon';
import Card from '../../../../shared/components/Card';
import { PresenceWorkerSearchRequest } from '../webservices/presence-worker-search/PresenceWorkerSearchRequest';
import { PresenceWorkerSearchTask } from '../webservices/presence-worker-search/PresenceWorkerSearchTask';
import debounce from 'lodash/debounce';
import PropTypes from 'prop-types';
import './PresenceCard.css';
import Alert from 'react-s-alert';
import { PsWorker } from '../PsWorker';
import { PsPresence } from '../PsPresence';
import CompanyAutocomplete from '../../../../shared/components/CompanyAutocomplete';

export class PresenceAddOutsourcesCard extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            outsources: [],
            outsourcesLoading: false,
            workers: [],
            workersTextSearch: '',
            workersLoading: false,
            outsourceTextSearch: '',
            selectedOutsource: null,
        };
    }

    render() {
        const { presences } = this.props;
        const {
            outsourcesLoading,
            workers,
            workersLoading,
            workersTextSearch,
            selectedOutsource,
        } = this.state;

        return (
            <Card loading={outsourcesLoading || workersLoading} className="worker-card">
                <CardHeader
                    title={I18nUtils.tr('TR_ANADIR_TRABAJADORES')}
                    rightOptions={
                        <HeaderSearchRefreshFilterOptions
                            enableSearch={false}
                            enableFilter={false}
                            enableRefresh={false}
                            moreOptions={this.moreOptions()}
                        />
                    }
                />
                <CardBody>
                    <Row>
                        <Col md={6} lg={6}>
                            <div className="form-group">
                                <label>{I18nUtils.tr('TR_SUBCONTRATA')}</label>
                                <CompanyAutocomplete
                                    id={'MONTHLY_COMPANY_AUTOCOMPLETE'}
                                    company={this.state.selectedOutsource}
                                    onChange={this.handleChangeOutsource}
                                />
                            </div>
                        </Col>
                        <Col md={6} lg={6}>
                            <div className="form-group">
                                <div className="form-line">
                                    <label>{I18nUtils.tr('TR_TRABAJADOR')}</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        onChange={this.changeSearchWorker}
                                        disabled={!selectedOutsource}
                                        value={workersTextSearch}
                                    />
                                </div>
                            </div>
                        </Col>
                    </Row>
                    <PsTable>
                        {
                            workers.map(worker => {
                                const isSelected = presences.find(p => p.isWorkerPresence(worker.id()));
                                const classes = classNames({ 'tr-disabled': isSelected });

                                return (
                                    <tr key={worker.id()} className={classes}>
                                        <td>{worker.completeName()}</td>
                                        <td>
                                            <ButtonIcon
                                                icon="add"
                                                onClick={() => this.selectWorkerAsPresence(worker)}
                                                disabled={isSelected}
                                            />
                                        </td>
                                    </tr>
                                );
                            })
                        }
                    </PsTable>
                </CardBody>
            </Card>
        );
    }

    moreOptions() {
        const { workers } = this.state;
        const { presences } = this.props;
        const allWorkersHavePresence = workers.every(w => presences.some(p => p.isWorkerPresence(w.id())));

        return [
            {
                id: 'add-all',
                title: I18nUtils.tr('TR_ANADIR_TODOS'),
                active: false,
                disabled: workers.length === 0 || allWorkersHavePresence,
                onClick: this.selectAllWorkersAsPresences,
            },
        ];
    }

    handleChangeOutsource = (value) => {
        if ( value && value[0] ) {
            this.setState({ selectedOutsource: value[0] });
        } else {
            this.setState({
                selectedOutsource: null,
                workersTextSearch: '',
                workers: []
            });
        }
    }

    searchWorkers = () => {
        const { workersTextSearch, selectedOutsource } = this.state;

        if ( !workersTextSearch || workersTextSearch.length === 0 ) {
            this.setState({ workers: [] });
        }

        if ( workersTextSearch && workersTextSearch.length > 2 ) {
            const request = new PresenceWorkerSearchRequest(selectedOutsource.id);
            request.setTerm(workersTextSearch);

            new PresenceWorkerSearchTask(request)
                .onPreExecution(() => this.setState({ workersLoading: true }))
                .onSuccess(res => {
                    this.setState({
                        workers: PsWorker.fromBackendArray(res.data || []),
                    });
                })
                .onFail(error => Alert.error(error))
                .onPostExecution(() => this.setState({ workersLoading: false }))
                .execute();
        }
    };

    searchWorkersDebounced = debounce(this.searchWorkers, 1000);

    changeSearchWorker = (event) => {
        const workersTextSearch = event.target.value;
        this.setState({ workersTextSearch }, this.searchWorkersDebounced);
    };

    selectAllWorkersAsPresences = () => {
        const { workers } = this.state;
        const { presences, selectPresences } = this.props;
        const newPresences = [];

        workers.forEach(worker => {
            const isSelected = presences.some(p => p.isWorkerPresence(worker.id()));
            if ( !isSelected ) newPresences.push(PsPresence.fromWorker(worker));
        });

        selectPresences([...presences, ...newPresences]);
    };

    selectWorkerAsPresence = (worker) => {
        this.props.selectPresence(PsPresence.fromWorker(worker));
    };
}

PresenceAddOutsourcesCard.propTypes = {
    presences: PropTypes.array.isRequired,
    selectPresence: PropTypes.func.isRequired,
    selectPresences: PropTypes.func.isRequired,
};



// WEBPACK FOOTER //
// ./src/app/my-outsources/presence/management/add/PresenceAddOutsourcesCard.jsx